/* eslint-disable @next/next/no-img-element */
import { Box, Container, Typography } from "@mui/material";
import React from "react";
import CookieDialog from "../cookies/cookies-dialog";

const Footer: React.FC = () => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.primary.main,
        width: "100%",
      })}
    >
      <Box></Box>
      <Container maxWidth="lg">
        <Box
          sx={(theme) => ({
            paddingY: theme.spacing(3),
            backgroundColor: theme.palette.primary.main,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            [theme.breakpoints.down("md")]: {
              flexDirection: "column",
              gap: theme.spacing(2),
            },
          })}
        >
          <Typography
            sx={(theme) => ({
              color: "white",
              textAlign: "center",
              fontWeight: "bold",
            })}
          >
            &copy; {new Date().getFullYear()} - Pivovarská Restaurace Čáslav
          </Typography>
          <Box sx={{ color: "white !important" }}>
            <CookieDialog showFab />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
